import { ComponentProps, FC } from 'react';
import { useForm, useFormContext, UseFormReturn } from 'react-hook-form';

import { Form as FormProvider } from '@/components';

type ControlsFormFieldValues = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
};
export const useControlsForm = useForm<ControlsFormFieldValues>;
export const useControlsContext = useFormContext<ControlsFormFieldValues>;

type FormProps = {
  onSubmit: (values: ControlsFormFieldValues) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  defaultValues?: any;
  controlsFormArg?: UseFormReturn<ControlsFormFieldValues>;
} & ComponentProps<typeof FormProvider>;

export const Form: FC<FormProps> = ({ defaultValues, onSubmit, controlsFormArg, ...delegated }) => {
  const form = useControlsForm({
    defaultValues,
  });

  const controlsForm = controlsFormArg ?? form;

  const handleOnSubmit = (values: ControlsFormFieldValues) => {
    onSubmit?.(values);
  };

  return (
    <FormProvider {...controlsForm}>
      <form {...delegated} onSubmit={controlsForm.handleSubmit(handleOnSubmit)} />
    </FormProvider>
  );
};
